'use client';
import { Table } from './table.js';
import { TableBody } from './table-body.js';
import { TableCell } from './table-cell.js';
import { TableFoot } from './table-foot.js';
import { TableHead } from './table-head.js';
import { TableHeaderCell } from './table-header-cell.js';
import { TableRow } from './table-row.js';

/**
 * Table component, used to display tabular data. Renders a native HTML table element.
 *
 * @example
 * <Table>
 *   <Table.Head>
 *     <Table.Row>
 *       <Table.HeaderCell>Name</Table.HeaderCell>
 *       <Table.HeaderCell>Age</Table.HeaderCell>
 *     </Table.Row>
 *   </Table.Head>
 *   <Table.Body>
 *     <Table.Row>
 *       <Table.Cell>John</Table.Cell>
 *       <Table.Cell>25</Table.Cell>
 *     </Table.Row>
 *   </Table.Body>
 *   <Table.Foot>
 *     <Table.Row>
 *       <Table.Cell>Total</Table.Cell>
 *       <Table.Cell>2</Table.Cell>
 *     </Table.Row>
 *   </Table.Foot>
 * </Table>
 */
const TableComponent = Object.assign(Table, {
    Head: TableHead,
    Body: TableBody,
    Row: TableRow,
    Cell: TableCell,
    HeaderCell: TableHeaderCell,
    Foot: TableFoot,
});
TableComponent.displayName = 'Table';
TableComponent.Head.displayName = 'Table.Head';
TableComponent.Body.displayName = 'Table.Body';
TableComponent.Row.displayName = 'Table.Row';
TableComponent.Cell.displayName = 'Table.Cell';
TableComponent.HeaderCell.displayName = 'Table.HeaderCell';
TableComponent.Foot.displayName = 'Table.Foot';

export { TableComponent as Table, TableBody, TableCell, TableFoot, TableHead, TableHeaderCell, TableRow };
